import { useStorage } from '@vueuse/core'

export const userSettings = useStorage('user-settings', {})
